import QuestionnaireLayout from '../layout/QuestionnaireLayout.vue'

const qs1_routes = []
const qs2_routes = []
const qs3_routes = []
const qs4_routes = []
let qsNumber = 1

for (let i = 0; i < 20; i++) {
  let n = i + 1 < 10 ? '0' + (i + 1) : i + 1 + ''
  qs1_routes.push({
    path: `section1/${i + 1}`,
    name: 'question' + qsNumber++,
    component: () =>
      import(
        /* webpackChunkName: "questionnaire" */ `../views/questionnaire/qs1/qs1-${n}.vue`
      ),
  })
}

for (let i = 0; i < 21; i++) {
  let n = i + 1 < 10 ? '0' + (i + 1) : i + 1 + ''
  qs2_routes.push({
    path: `section2/${i + 1}`,
    name: 'question' + qsNumber++,
    component: () =>
      import(
        /* webpackChunkName: "questionnaire" */ `../views/questionnaire/qs2/qs2-${n}.vue`
      ),
  })
}

for (let i = 0; i < 11; i++) {
  let n = i + 1 < 10 ? '0' + (i + 1) : i + 1 + ''
  qs3_routes.push({
    path: `section3/${i + 1}`,
    name: 'question' + qsNumber++,
    component: () =>
      import(
        /* webpackChunkName: "questionnaire" */ `../views/questionnaire/qs3/qs3-${n}.vue`
      ),
  })
}

for (let i = 0; i < 8; i++) {
  let n = i + 1 < 10 ? '0' + (i + 1) : i + 1 + ''
  qs4_routes.push({
    path: `section4/${i + 1}`,
    name: 'question' + qsNumber++,
    component: () =>
      import(
        /* webpackChunkName: "questionnaire" */ `../views/questionnaire/qs4/qs4-${n}.vue`
      ),
  })
}

export default {
  path: '/questionnaire',
  component: QuestionnaireLayout,
  children: [
    {
      path: '',
      name: 'begin',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () =>
        import(
          /* webpackChunkName: "questionnaire" */ '../views/questionnaire/begin.vue'
        ),
    },
    {
      path: 'section1',
      name: 'section1',
      component: () =>
        import(
          /* webpackChunkName: "questionnaire" */ '../views/questionnaire/section1.vue'
        ),
    },
    ...qs1_routes,
    {
      path: 'section2',
      name: 'section2',
      component: () =>
        import(
          /* webpackChunkName: "questionnaire" */ '../views/questionnaire/section2.vue'
        ),
    },
    ...qs2_routes,
    {
      path: 'section3',
      name: 'section3',
      component: () =>
        import(
          /* webpackChunkName: "questionnaire" */ '../views/questionnaire/section3.vue'
        ),
    },
    ...qs3_routes,
    {
      path: 'section4',
      name: 'section4',
      component: () =>
        import(
          /* webpackChunkName: "questionnaire" */ '../views/questionnaire/section4.vue'
        ),
    },
    ...qs4_routes,
  ],
}
